if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.productFormVisible = true;
      this.rafPending = false;

      // Start hidden until observer determines visibility
      this.classList.add('sticky-atc-panel--out');

      if ('IntersectionObserver' in window) {
        this.bindEvents();
      }

      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll);
      this.handleScroll();
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.productFormVisible = entry.isIntersecting;
            this.updateMobileVisibility();
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            // Desktop: show sticky bar when the product info is NOT visible
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      }, { threshold: 0 });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);
    }

    handleScroll() {
      if (this.rafPending) return;
      this.rafPending = true;
      requestAnimationFrame(() => {
        this.rafPending = false;
        this.updateMobileVisibility();
      });
    }

    updateMobileVisibility() {
      if (!this.productForm || theme.mediaMatches.md) return;

      const formTop = this.productForm.getBoundingClientRect().top + window.scrollY;
      const triggerPoint = Math.max(420, formTop - (window.innerHeight * 0.35));
      const shouldShow = window.scrollY > triggerPoint && !this.productFormVisible;

      this.classList.toggle('sticky-atc-panel--out', !shouldShow);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
